import { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import useSession from '../hooks/useSession';
import authAPI from '../services/auth';
import paymentAPI from '../services/payment';
import projectAPI from '../services/project';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import CheckoutForm from './CheckoutForm'
import { UserContext } from '../context/UserContext';

const Payments = () => {
  const [stripePromise, setStripePromise] = useState(() => loadStripe('pk_test_edpI7JhPjvcfsRQc8j78GKuR'))
  const [session] = useSession()
  const [user, setUser] = useState(false)
  const [projectInfo, setProjectInfo] = useState(false)
  const [price, setPrice] = useState(0)
  const [options, setOptions] = useState(false)
  const navigate = useNavigate();
  const { data } = useParams();
  const { removeCustomItem, getCustomItem } = useContext(UserContext)


  useEffect(() => {
    (async () =>{
      try {
        if (session && !user) {
          const res = await authAPI.get({jwt: session})
          setUser(res.data)

          const projectInfo = JSON.parse(atob(data))
          setProjectInfo(projectInfo)
          // setPaymentUrl(`/widget#project/posted/${projectInfo.hash_id_completed_form}/payment/${projectInfo.hash_id_bill}`)
          setPrice(projectInfo.total)
          const response = await paymentAPI.post({
            amount: projectInfo.total,
            description: '',
            customer: res.data.email,
            currency: res.data.currency || 'usd',
          }, session)
          setOptions(response.data)
        } else if(!user){
          navigate('/login')
        }
      } catch (error) {
        navigate('/login')
      }
    })()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const automaticPayment = async () => {
    let hashIdProject = null;
    if (user && user.data && user.data.view) {
      hashIdProject = user.data.view.hash_id_project
    } else if (getCustomItem('bunny.Project')) {
      const storageData = JSON.parse(getCustomItem('bunny.Project'))
      hashIdProject = storageData.hash_id_project
    }

    if (hashIdProject) {
      const data = {
        hash_id_project: hashIdProject,
        hash_id_widget_completed_form: projectInfo.hash_id_completed_form
      }
      await projectAPI.post({jwt: session, payload: data})
      removeCustomItem('bunny.Project')
      navigate(`/widget#project/posted/${projectInfo.hash_id_completed_form}/payment/${projectInfo.hash_id_bill}/success`)
    }
  }

  return (
    <section className="container mx-auto px-4">
      {
        options ? (
          <input
            type="button"
            className="font-semibold text-base text-white bg-[#FE8C18] hover:bg-[#e77707] focus:ring-4 focus:ring-[#fc9d3e] px-6 py-4 rounded focus:outline-none"
            value="submit"
            onClick={() => automaticPayment()}
          />
          
        ) :
        (
          <div>...Loading</div>
        )
      }
    </section>
  )
}
export default Payments

/* <Elements stripe={stripePromise} options={options}>
    <CheckoutForm
      price={price}
      formId={projectInfo.hash_id_completed_form}
      billId={projectInfo.hash_id_bill}
    />
  </Elements> */
